// PaymentMethodToggle.jsx — elegir Transferencia o Tarjeta, compartido por Persona y Empresa.

import React from 'react'
import { trackCta } from '../../lib/analytics.js'

function PaymentMethodToggle({ method, onChange, transferLabel = "Transferencia", cardLabel = "Tarjeta" }) {
  return (
    <div className="pay-toggle">
      <button
        type="button"
        className={`pay-toggle-btn ${method === "transfer" ? "active" : ""}`}
        onClick={() => {
          trackCta("pay_transfer")
          onChange("transfer")
        }}
      >
        {transferLabel}
      </button>
      <button
        type="button"
        className={`pay-toggle-btn ${method === "card" ? "active" : ""}`}
        onClick={() => {
          trackCta("pay_card")
          onChange("card")
        }}
      >
        {cardLabel}
      </button>
    </div>
  );
}

export { PaymentMethodToggle };
